<template>
    <div class="topicList">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>话题PK</el-breadcrumb-item>
            <el-breadcrumb-item>查询话题</el-breadcrumb-item>
        </el-breadcrumb>
        <el-table class="topic-list-table" :data="topicList" stripe border>
            <el-table-column label="话题ID" align='center' width="100">
                <template scope="scope">
                    <span>{{scope.row.topicId}}</span>
                </template>
            </el-table-column>
            <el-table-column label="标题" align='center' width="240">
                <template scope="scope">
                    <span>{{scope.row.topicTitle}}</span>
                </template>
            </el-table-column>
            <el-table-column label="链接" align='center' min-width="313">
                <template scope="scope">
                    <a target="_blank" :href="baseUrl + scope.row.topicId">{{baseUrl + scope.row.topicId}}</a>
                </template>
            </el-table-column>
            <el-table-column label="参与人数" align='center'  width="120">
                <template scope="scope">
                    <span>{{scope.row.participants}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align='center' min-width="150">
                <template scope="scope">
                    <el-button size="small" type="info" @click="editTopic(scope.$index,scope.row)">编辑</el-button>
                    <el-button size="small" type="danger" @click="deleteTopic(scope.row.topicId)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页器-->
        <!-- <el-pagination class="page-control" layout="prev, pager, next" :total="topicListLength" @current-change=""></el-pagination> -->
        <!--编辑弹框-->
        <el-dialog title="编辑-话题PK" v-model="dialogFormVisible" :modal-append-to-body="false" :close-on-click-modal="false">
            <el-form :model="editTopicForm" :rules="validateRules" ref="editTopicForm" label-width="100px" class="editTopicForm">
                <el-form-item label="话题名称" prop="topicTitle">
                    <el-input v-model="editTopicForm.topicTitle" auto-complete="off" placeholder="请输入话题名称"></el-input>
                </el-form-item>
                <el-form-item label="焦点图类别" prop="focusImgType">
                    <el-select v-model="editTopicForm.focusImgType" placeholder="请选择">
                      <el-option v-for="typeItem in focusImgType" :key="typeItem.value" :label="typeItem.label" :value="typeItem.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="editTopicForm.focusImgType === 'image'" label="焦点图" prop="focusImgUrl">
                    <el-input v-model="editTopicForm.focusImgUrl" auto-complete="off" placeholder="请输入焦点图地址"></el-input>
                </el-form-item>
                <el-form-item v-if="editTopicForm.focusImgType === 'video'" label="焦点视频" prop="focusImgUrl">
                    <el-input v-model="editTopicForm.focusImgUrl" auto-complete="off" placeholder="请输入焦点图地址"></el-input>
                </el-form-item>
                <el-form-item v-if="editTopicForm.focusImgType === 'video'" label="视频封皮"prop="focusVideoPoster">
                    <el-input v-model="editTopicForm.focusVideoPoster" auto-complete="off" placeholder="请输入视频封皮地址"></el-input>
                </el-form-item>
                <!-- <el-form-item label="焦点图" prop="focusImgUrl">
                    <el-input v-model="editTopicForm.focusImgUrl" auto-complete="off" placeholder="请输入焦点图地址"></el-input>
                </el-form-item> -->
                <el-form-item label="话题内容" prop="topicContent">
                    <el-input v-model="editTopicForm.topicContent" type="textarea" auto-complete="off" placeholder="请输入话题内容（选填）"></el-input>
                </el-form-item>
                <el-form-item label="参与人数" prop="participants">
                    <el-input v-model="editTopicForm.participants" auto-complete="off" placeholder="请输入参与人数（选填）"></el-input>
                </el-form-item>
                <el-form-item label="开启分享" prop="isShare">
                    <el-switch v-model="editTopicForm.isShare" on-value="1" off-value="0"></el-switch>
                </el-form-item>
                    <template v-if="Number(editTopicForm.isShare)">
                        <!--<el-form-item label="分享链接" prop="shareUrl">-->
                            <!--<el-input v-model="editTopicForm.shareUrl" auto-complete="off" placeholder="请输入分享链接（选填）"></el-input>-->
                        <!--</el-form-item>-->
                        <el-form-item label="分享图（尺寸200*200）" prop="shareImgUrl">
                            <el-input v-model="editTopicForm.shareImgUrl" auto-complete="off" placeholder="请输入分享图地址"></el-input>
                        </el-form-item>
                        <el-form-item label="分享标题" prop="shareTitle">
                            <el-input v-model="editTopicForm.shareTitle" auto-complete="off" placeholder="请输入分享标题"></el-input>
                        </el-form-item>
                        <el-form-item label="分享描述" prop="shareDes">
                            <el-input v-model="editTopicForm.shareDes" type="textarea" auto-complete="off" placeholder="请输入分享描述"></el-input>
                        </el-form-item>
                    </template>
              </el-form>
            <div class="topic-preview-box">
                <div class="header-image" v-if="editTopicForm.focusImgUrl !== null && editTopicForm.focusImgUrl !== ''">
                    <img v-if="editTopicForm.focusImgType === 'image'" :src="editTopicForm.focusImgUrl" alt="请输入正确的图片地址">
                    <video v-if="editTopicForm.focusImgType === 'video'" :src="editTopicForm.focusImgUrl" :poster="editTopicForm.focusVideoPoster" control></video>
                </div>
                <div class="description" v-if="editTopicForm.topicTitle !== null && editTopicForm.topicTitle !== ''">
                    <!--<div class="desc-icon">概述</div>-->
                    <h5>{{editTopicForm.topicTitle}}</h5>
                    <span class="desc-content" v-if="editTopicForm.topicContent !== null && editTopicForm.topicContent !== ''">{{editTopicForm.topicContent}}</span>
                </div>
                <div class="say-sth" v-if="editTopicForm.topicTitle !== null && editTopicForm.topicTitle !== ''">
                    <img src="http://tstatic.toptest.yidianzixun.com.ks3-cn-beijing.ksyun.com/public/files/ydlg1495784109418.jpeg">
                    <span>一点资讯用户</span>
                    <div>说点什么</div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="editSubmit('editTopicForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
import { mapGetters } from 'vuex';
export default {
  name: 'topicList',
      data () {
          var imgUrl = (rule, value, callback) => {
              var reg = new RegExp('^http://');
              if (value == '' || value == '请输入焦点图地址' || value == '请填写分享图片地址') {
                  callback(new Error('请填写图片地址'));
              } else if (! reg.test(value)) {
                  callback(new Error('您填写的地址不正确'));
              } else {
                  callback();
              }
          }
          return {
              topicList: null,
              topicListLength: 0,
              currentPage: 1,
              baseUrl: 'https://top.yidianzixun.com/wxAuth/wx_login?hUri=' + CONFIG.HOST + '/topicPK/topics/topic/',
              editTopicForm: {
                  topicTitle: '',
                  topicContent: '',
                  participants: '',
                  createUser: -1,
                  focusImgUrl: '',
                  isShare: '0',
                  shareTitle: '',
                  shareDes: '',
                  shareUrl: '',
                  shareImgUrl: '',
                  focusImgType: null,
                  focusVideoPoster: null
              },
              focusImgType: [
                {
                  value: 'image',
                  label: '图片'
                },
                {
                  value: 'video',
                  label: '视频'
                }
              ],
              validateRules: {
                  topicTitle: [
                      { required: true, message: '请填写话题标题', trigger: 'change' }
                  ],
                  focusImgUrl: [
                      { required: true, validator: imgUrl, trigger: 'change' }
                  ],
                  shareDes: [
                      { required: true, message: '请填写分享描述', trigger: 'change' }
                  ],
                  shareTitle: [
                      { required: true, message: '请填写分享标题', trigger: 'change' }
                  ],
                  shareImgUrl: [
                      { required: true, validator: imgUrl, trigger: 'change' }
                  ],
                  focusImgType: [
                    { required: true, message: '请选择焦点图类别', trigger: 'change' }
                  ],
                  focusVideoPoster: [
                      { required: true, validator: imgUrl, trigger: 'change' }
                  ],
                  topicContent: [
                      { required: true, message: '请填写话题内容', trigger: 'change' }
                  ]
              },
              editIndex: -1,
              dialogFormVisible: false
          };
      },
      mounted(){
          this._init();
      },
      computed: {
          ...mapGetters({
              userInfo: 'getUserInfo'
          })
      },
      methods: {
          _getTopicListCount() {
              this.$http.get(CONFIG.HOST + "/topicPK/topics/getAllTopics?t=" + TOOL.getCurrentTime()).then((response)=>{
                  let result = response.body;
                  if (result && result.status === 1) {
                      this.topicList = result.data;
                  } else {
                      this.$notify.error({
                          message: result.message
                      });
                  }
              }, (response)=>{
                  console.log(response);
              });
          },
//          _getTopicPageList(pageId = 1){
//              this.$http.get(CONFIG.HOST + '/topic/listPaging/' + pageId + '?t=' + TOOL.getCurrentTime()).then((response)=>{
//                  let result = response.body;
//                  if (result && result.status === 1) {
//                      this.topicList = result.data.listPaging;
//                  } else {
//                      this.$notify.error({
//                          message: result.message
//                      });
//                  }
//              },(response)=>{
//                console.log(response);
//              });
//          },
          _confirmMessage(message, success = ()=>{}, cancel = ()=>{}) {
              this.$confirm(message, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then(success).catch(cancel);
          },
          //编辑话题
          editTopic(index, row) {
              let focusImgUrl = row.focusImgUrl,
                focusImgType,
                focusVideoPoster,
                focusImgTypeFlag = focusImgUrl.indexOf("?poster=");



              this.dialogFormVisible = true;
              Object.assign(this.editTopicForm, row);
              this.editTopicForm.isShare = String(row.isShare);

              if (focusImgTypeFlag !== -1) {
                focusImgType = this.focusImgType[1].value;
                focusVideoPoster = decodeURIComponent(focusImgUrl.split('=')[1]);
                this.editTopicForm.focusVideoPoster = focusVideoPoster;
                this.editTopicForm.focusImgUrl = decodeURIComponent(focusImgUrl.split('?')[0]);
              } else {
                focusImgType = this.focusImgType[0].value;
              }
              this.editTopicForm.focusImgType = focusImgType;
              console.log(this.editTopicForm);
              this.editIndex = index;
          },
          //编辑话题提交
          editSubmit(formName) {
              let flag = true,
                editTopicForm = {};
              this.$refs[formName].validate((valid) => {
                  if (!valid) {
                      flag = false;
                      return false;
                  }
              });
              if (!flag) {
                  this.$notify.error({
                      message: '请检查要修改的数据'
                  });
                  return;
              }
              this.editTopicForm.isShare = Number(this.editTopicForm.isShare);
              for (var key in this.editTopicForm) {
                if (key === 'focusImgUrl' && this.editTopicForm.focusImgType === 'video') {
                  editTopicForm.focusImgUrl = this.editTopicForm[key] + "?poster=" + encodeURIComponent(this.editTopicForm['focusVideoPoster']);
                } else {
                  editTopicForm[key] = this.editTopicForm[key];
                }
              }
              this.$http.put(CONFIG.HOST + '/topicPK/topics/updTopic', editTopicForm).then((response) => {
                  let result = response.body;
                  if (result && result.status === 1) {
                      Object.assign(this.topicList[this.editIndex], this.editTopicForm);
                      this.$notify.success({
                          message: '【营销平台】话题PK修改成功'
                      });
                      this.dialogFormVisible = false;
                  } else {
                      this.$notify.error({
                          message: result.message
                      });
                  }
              }, (response) => {
                  console.log(response);
              });
          },
          deleteTopic(topicId) {
              this._confirmMessage('是否确定删除topicId=' + topicId + '的话题？', ()=>{
                  if (topicId < 0) {
                      this.$notify.error({
                          message: '【营销平台】topicId=' + topicId + '的话题不存在'
                      });
                      return;
                  }
                  this.$http.delete(CONFIG.HOST + '/topicPK/topics/delTopic2/' + topicId).then((response)=>{
                      let result = response.body;
                      if (result && result.status === 1) {
                          this.$notify.success({
                              message: '【营销平台】成功删除topicId=' + topicId + '的话题'
                          });
                          this._getTopicListCount();
                          //this._getTopicPageList(this.currentPage);
                      } else {
                          this.$notify.error({
                              message: result.message
                          });
                      }
                  },(response)=>{
                      console.log(response);
                  });
              });
          },
//          changePage(page){
//              this.currentPage = page;
//              this._getTopicPageList(page);
//          },
          _init() {
              this._getTopicListCount();
              //this._getTopicPageList();
          }
      }
}
</script>

<style lang="less">
    .topicList{
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
        .topic-list-table{
            min-width: 980px;
        }
        .page-control{
            margin: 20px auto 0 auto;
        }
        .el-dialog--small {
            /*width: 65%;*/
            .editTopicForm {
                float: left;
                width: 50%;
            }
            .topic-preview-box {
                margin: 0 0 20px 20px;
                float: left;
                width: 45%;
                height: 547px;
                border: 1px solid #bfcbd9;
                border-radius: 6px;

                .header-image {
                    width: 100%;
                    display: block;
                    img {
                        width: 100%;
                    }
                    video{
                      width: 100%;
                    }
                }
                .description {
                    padding: 10px 11px;
                    font-size: 100%;
                    text-align: center;
                    border-bottom: 3px solid #CFCFCF;
                    h5 {
                        margin-bottom: 5px;
                    }
                    .desc-content {
                        color: #9C9C9C;
                        font-size: 10px;
                        word-break: break-all;
                    }
                }
                .say-sth {
                    border: 2px dashed #9C9C9C;
                    width: 140px;
                    height: 140px;
                    margin: 20px;
                    img {
                        width: 18px;
                        border-radius: 50%;
                        float: left;
                        margin: 5px 0 5px 5px;
                    }
                    span {
                        font-size: 12px;
                        float: left;
                        margin: 5px;
                    }
                    div {
                        margin-top: 64px;
                        font-size: 14px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// List.vue?b15e66c8